module.exports = {};



//////////////////
// WEBPACK FOOTER
// /~/babel-polyfill/~/core-js/modules/_iterators.js
// module id = 89
// module chunks = 31